<template>
  <div class="cart cart-page">
    <CreateNewOrder
        :type="'cart'"
        :yongLiaoList="yongLiaoList"
        @setModalState="setModalState"
        @editDesignInfo="editDesignInfo2"
        :fieldData="fieldData"
        :designInfo="designInfoTemp"
        :productModalshow="showDetailModal"
        :shoppingCarId="shoppingCarId"
        :shoppingCartType="shoppingCartType"
    />


    <van-tabs
        :class="
        $store.getters.shop.config.enable_product_store ? 'two-tab' : 'one-tab'
      "
        v-model="activeHeader"
        @click="getList()"
    >
      <van-tab
          title="窗帘购物车"
          name="chuanglian"
      >

        <van-checkbox-group v-model="checkedList" ref="checkboxGroup">
        <div class="rooms">

          <van-empty v-if="data1.length == 0"/>
          <div v-for="(item1, index) in data1" class="room">
            <div v-if="item1[0]&&item1[0].installationLocationName" class="room-name">
              {{ item1[0].installationLocationName }}

              <!--<van-icon
                @click="deleteRoom(index)"
                class="delete-icon"
                name="delete-o"
              />-->
            </div>
            <div v-for="(item, index2) in item1">
              <div class="item">
                <div class="top-info">
                  <van-checkbox :name="item.shoppingCarId"></van-checkbox>
                  <div class="info-img" :style="{backgroundImage:'url('+item.designImageUrl+')'}"></div>
<!--                  <img class="product-avatar" :src="item.designImageUrl"/>-->
                  <div class="right-info">
                    <div class="tit">{{ item.name }}</div>
                    <!--<div>
                                        <div v-if="!$$item[0]"> {{$$item.label}}:{{$$item.text}}</div>
                                        <div  v-else>{{$$item[0].label}}:<span v-for="item1 in $$item">{{item1.text}}、</span></div>
                                    </div>-->
                    <div v-for="vo in fieldData">
                      <div
                          v-if="
                          vo.label == '房间选择' &&
                          item.installationLocationName
                        "
                      >
                        {{ vo.label }}:{{ item.installationLocationName }}
                      </div>
                      <div v-else-if="vo.label == '颜色分类' && item.name">
                        {{ vo.label }}:{{ item.name || "" }}
                      </div>
                      <div
                          v-else-if="vo.label == '面料方向' && item.processType"
                      >
                        {{ vo.label }}:{{ item.processType == 'FixHeight' ? '买宽' : '买高' }}
                      </div>
                      <div
                          v-else-if="
                          vo.label == '转角' && (item.leftRadian || item.rightRadian)
                        "
                      >
                        {{ item.leftRadian ? "左转角："+item.leftRadian : "" }} &nbsp;
                        {{ item.rightRadian ? "右转角："+item.rightRadian : "" }}
                      </div>
                      <div
                          v-else-if="
                          vo.label == '粘贴方向' &&
                          item.selectedPasteDirectionName
                        "
                      >
                        {{ vo.label }}:{{
                          item.selectedPasteDirectionName || ""
                        }}
                      </div>
                      <div
                          v-else-if="
                          vo.label == '加工方式' &&
                          item.selectedInstallationCraftName
                        "
                      >
                        {{ vo.label }}:{{
                          item.selectedInstallationCraftName || ""
                        }}
                      </div>
                      <div
                          v-else-if="
                          vo.label == '分片方式' && item.selectedOpenModeName
                        "
                      >
                        {{ vo.label }}:{{ item.selectedOpenModeName || "" }}
                      </div>
                      <div
                          v-if="
                          vo.label == '复杂加工' && item.selectedExpandItemNames
                        "
                      >
                        {{ vo.label }}:{{ item.selectedExpandItemNames || "" }}
                      </div>
                      <div
                          v-if="
                          vo.label == '褶倍' && item.selectedPleatTimeName
                        "
                      >
                        {{ vo.label }}:{{ item.selectedPleatTimeName || "" }}
                      </div>
                      <div
                          v-else-if="
                          vo.label == '绑带' && item.bangDaiProductNumber
                        "
                      >
                        {{ vo.label }}:{{ item.bangDaiProductNumber || "" }}
                      </div>
                    </div>
                    <div>
                      墙宽：{{ item.width }} 米 帘高：{{ item.height }}米
                    </div>
                  </div>
                </div>
                <div class="bottom-info">
                  <img
                      @click="openEditModal(item)"
                      class="edit-icon"
                      src="/roomicon/zidingyi-b.png"
                  />
                  <van-icon
                      @click="deleteItem(index,index2)"
                      class="delete-icon edit-icon"
                      name="delete-o"
                  />
                  <div>
                    ¥{{ setPriceRatio(item.price) }}/{{ item.quantity }}米 合计:{{ setPriceRatio(item.amount) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-submit-bar
            style="bottom: 50px"
            v-if="data1.length > 0"
            :price="total1"
            :disabled="!shopCartSubmit"
            button-text="提交订单"
            @submit="onSubmit">
          <van-checkbox @click="checkAll" >全选</van-checkbox>
        </van-submit-bar>

        </van-checkbox-group>
      </van-tab>
      <!--<van-tab :title="$store.getters.confirmorderid?'临时单修改':'窗帘购物车'" name="chuanglian" >
               <div class="rooms">
                 <van-empty v-if="data1.length==0" />
                  <div v-for="(item,index) in data1" class="room">
                     <div v-if="item.list[0]" class="room-name">
                       {{item.list[0].room_name}}
                      <van-icon @click="deleteRoom(index)" class='delete-icon' name="delete-o" />
                     </div>
                     <div v-for="($item,index2) in item.list" class="item">
                        <div class="top-info">
                            <img class="product-avatar" :src="$item.imageOne" />
                            <div class="right-info">
                                <div class="tit">{{$item.name}}</div>
                                <div v-for="$$item in $item.list">
                                    <div v-if="!$$item[0]"> {{$$item.label}}:{{$$item.text}}</div>
                                    <div  v-else>{{$$item[0].label}}:<span v-for="item1 in $$item">{{item1.text}}、</span></div>
                                </div>
                            </div>
                         </div>
                         <div class="bottom-info">
                              <img @click="openEditModal($item,index,index2)" class="edit-icon" src="/roomicon/zidingyi-b.png">
                              <van-icon @click="deleteItem(index,index2)" class='delete-icon edit-icon' name="delete-o" />
                             <div>
                                 墙宽：{{$item.qiangkuan}} 米
                                 帘高：{{$item.liangao}}米
                                ¥{{$item.unit}}元/米
                             </div>
                         </div>
                     </div>
                  </div>
               </div>
               <van-submit-bar style="    bottom: 50px;" v-if="data1.length>0"  :price="3050" button-text="提交订单" @submit="onSubmit" />
            </van-tab >-->
      <van-tab style="padding-bottom: 55px" title="面料购物车" name="mianliao">
        <div class="mianliao-items">
          <div class="mianliao-item" v-for="(item, index) in mianliaoList">
            <img :src="item.curtainImageUrl1"/>
            <div class="info">
              <div>{{ item.productNumber }}</div>
              <div style="font-size: 12px">
                {{ item.fabricType }}：￥{{ setPriceRatio(item.price) }} * {{ item.quantity }}
                合计：{{ setPriceRatio(item.amount) }}
              </div>
              <van-icon
                  @click="deleteMianLiao(index)"
                  class="delete-icon"
                  name="delete-o"
              />
            </div>
          </div>

          <van-submit-bar
              style="bottom: 50px"
              v-if="mianliaoList.length > 0"
              :price="total2"
              button-text="提交订单"
              @submit="onSubmit"
          />
        </div>
      </van-tab>
    </van-tabs>
    <van-empty v-if="!cardslength && !loading">没有商品</van-empty>
    <Footer :count="data1.length || cardslength"></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import CreateNewOrder from "@/components/CreateNewOrder.vue";
import {Dialog} from "vant";
import {fieldData, TypeMaps} from "../dict";
import {Toast} from "vant";

export default {
  name: "Cart",
  components: {CreateNewOrder, Footer},
  data() {
    return {
      shoppingCarId: "",
      curtainOrderId: "",
      shoppingCartType: "",
      cart_index: [],
      yongLiaoList: [],
      fieldData: [],
      designInfo: {},
      designInfoTemp: {},
      showDetailModal: false,
      data1: this.$store.getters.carts,
      mianliaoList: this.$store.getters.cartsMianLiao,
      showAddress: false,
      address: {},
      isPhone: true,
      vouchers: [],
      phone: "",
      street: "",
      cardslength: 0,
      isShowOtherCartInfoPop: false,
      loading: true,
      customer: "",
      name: "",
      design: {},
      cards: [],
      activeHeader: "chuanglian",
      show: false,
      isShowCartInfoPop: false,
      isShowCartInfoPop2: false,
      cart_info: {},
      total_price: 0,
      comment: "",
      checkedList: [],
      allchecked: false,
      shopCartSubmit: false,
    };
  },
  computed: {
    total1() {
      let total = 0;

      if(this.checkedList.length == 0)
        return total;

      this.data1.map((item) => {
        //  item = item||[]
        item.map && item.map((item1) => {
          if(this.checkedList.includes(item1.shoppingCarId)) {
            total = total + item1.amount
            this.shopCartSubmit = true
          }
        })
      })
      var aa = this.setPriceRatio(total * 100);

      return Number(aa);
    },
    total2() {
      let total = 0;
      this.mianliaoList.map((item) => {

        total = total + item.amount

      })
      var aa = this.setPriceRatio(total * 100);

      return Number(aa);

    }
  },
  watch: {},
  mounted() {
    this.activeHeader = this.$route.query.activeHeader || 'chuanglian';
    // debugger
    Object.entries(this.AddCartMethods).map(
        (item1) => (this[item1[0]] = item1[1].bind(this))
    );

    sessionStorage.setItem("confirmorderid", 0)
    this.$store.getters.confirmorderid = 0;

    this.fieldData = fieldData;
    this.getList();
  },

  methods: {
    checkAll() {
      this.allchecked = !this.allchecked;
      this.$refs.checkboxGroup.toggleAll(this.allchecked);
    },
    getList() {

      if (this.activeHeader == "chuanglian") {
        this.$http.post("private/curtainShoppingCars").then((res) => {
          res = res || [];
          let obj = {};
          res.map((item) => {
            if (!obj[item.installationLocationName]) {
              obj[item.installationLocationName] = [];
            }
            obj[item.installationLocationName].push(item);
          });
          this.data1 = Object.values(obj);
        });
      } else if (this.activeHeader == "mianliao") {
        this.$http.post("private/fabricShoppingCars").then((res) => {
          this.mianliaoList = res || [];
        });
      }
    },
    deleteMianLiao(index) {
      Dialog.confirm({
        title: "确认提醒",
        message: "删除该面料？",
        confirmButtonColor: "rgb(242, 71, 73)",
      })
          .then(() => {
            let shoppingCarId = this.mianliaoList[index].shoppingCarId;
            this.mianliaoList.splice(index, 1);
            // 删除购物车
            this.$http
                .post("private/fabricShoppingCar/delete", shoppingCarId)
                .then((res) => {
                  if(res) Toast(res || "删除成功！");
                });
          })
          .catch(() => {
            // on cancel
          });
    },
    editDesignInfo2(info, type = "edit", isColorType, index) {
      try {


        if (isColorType && info.list.colorType.value && this.shoppingCartType != "ZLDZ") {

          if(index == 0)
            info.imageOne = this.design.imageOne
          else {
            let product = this.zhubuList[index-1] || []
            info.imageOne = product.curtainImageUrl1
          }

        }

        // debugger
        if (type == "edit") {
          this.designInfoTemp = {...info};
        } else {
          info.cart_index = this.cart_index;
          this.designInfo = info;
          /*this.$store.commit("EDITS_CARTS", this.designInfo).then(() => {
            this.data1 = this.$store.getters.carts;
          });

          this.getList()
          Toast("保存成功！");*/
        }

      } catch (err) {
        console.log("user_err:", err);
      }
    },
    setModalState(v) {
      this.showDetailModal = v;
    },
    openEditModal(item1) {
      let that = this;

      // 根据购物车id 请求购物车详情
      this.$http
          .post("private/curtainShoppingCarDetail", item1.shoppingCarId)
          .then((res) => {
            this.$store.commit("SET_DESIGN_ID", res.id || 0 ) // 保存款式id
            this.shoppingCarId = item1.shoppingCarId;
            this.shoppingCartType = res.shoppingCartType;
            this.curtainOrderId = res.curtainOrderId;
            // .filter((item, index) => index % 3 == 0);
            let sel_room_text = res.installationLocationName || "客厅";
            let sel_room = this.fieldData
                .find((item) => item.name == "selectRoom")
                .items.find((item) => item.text == sel_room_text);
            let auto_room = false
            if(!sel_room) {
              auto_room = true
              // 自定义位置
              sel_room = {
                text:sel_room_text,
                value:"zidingyi",
                icon:"zidingyi",
              }
            }
            let param = {}
            let leftRadian = res.leftRadian || ''
            let rightRadian = res.rightRadian || ''

            // 用料
            // if (res.designDetailDTOS) {
            this.yongLiaoList = res.designDetailDTOS || []
            // }
            if (res.designCategory == "LianTou") {

              param = {
                selectRoom: sel_room,
                colorType: {
                  value: this.shoppingCartType == "ZLCPDS" ? res.zhuBuProductId : res.id,
                  text: this.shoppingCartType == "ZLCPDS" ? res.zhuBuProductName : res.name,
                  label: "颜色分类",
                  memo: "",
                },
                radian: [{
                  text: "左转角",
                  value: res.leftRadian || '',
                  name: "leftRadian"
                }, {
                  text: "右转角",
                  value: res.rightRadian || '',
                  name: "rightRadian"
                }],
                pasteDirection: {
                  text: res.selectedPasteDirection.optionDesc,
                  value: res.selectedPasteDirection.optionValue,
                }
              };

            } else {
              res.selectedExpandItems = res.selectedExpandItems || [];
              let selectedExpandItems = res.selectedExpandItems
                  .map((item, index) => {
                    return {
                      label: "复杂加工",
                      memo: item.memo,
                      value: item.id,
                      text: item.name,
                    };
                  })

              param = {
                selectRoom: sel_room,
                colorType: {
                  value: this.shoppingCartType == "ZLCPDS" ? res.zhuBuProductId : res.id,
                  text: this.shoppingCartType == "ZLCPDS" ? res.zhuBuProductName : res.name,
                  label: "颜色分类",
                  memo: "",
                },
                // mianliaoDir: {
                //   text: res.processType == 'FixWidth' ? '买高' : '买宽',
                //   value: res.processType == 'FixWidth' ? 'FixWidth' : 'FixHeight',
                // },
                jiagongfangshi: {
                  text: res.selectedInstallationCraft.optionDesc,
                  value: res.selectedInstallationCraft.optionValue,
                },
                pleatTimes: {
                  text: res.selectedPleatTime.name,
                  value: res.selectedPleatTime.id,
                },
                fenpianfangshi: {
                  text: res.selectedOpenMode.optionDesc,
                  value: res.selectedOpenMode.optionValue,
                  memo: res.selectedOpenMode.memo,
                },
                fuzhaJiagong: selectedExpandItems,
                bangdai: {
                  value: res.bangDaiProductId,
                  text: res.bangDaiProductNumber,
                },
              };

            }


            this.fieldData = fieldData;
            if (this.shoppingCartType == 'ZLDZ') {
              let _fieldData = fieldData.filter((item) => item.name != 'colorType')
              this.fieldData = _fieldData
            }
            // res.list =res.list||{}


            this.showDetailModal = true;
            let list = {};
            // this.getStyleData(res.id, 0, false).then(() => {
            this.getEditStyleData(res).then(() => {
              this.fieldData.map((item) => {
                let $item = param[item.name] || {};

                list[item.name] = list[item.name] || [];
                if (!item.ismulti) {
                  list[item.name] = {
                    value: $item.value,
                    text: $item.text,
                    label: item.label,
                    memo: $item.memo,
                  };
                } else {
                  list[item.name] = $item;
                }
              });

              this.designInfo.qiangkuan = res.width;
              this.designInfo.liangao = res.height;
              this.designInfo.list = list;
              this.designInfo.designId = res.id;
              this.designInfo.desc = res.curtainMemo;
              this.designInfo.room_name = sel_room_text;
              this.designInfo.auto_room = auto_room;
              this.designInfo.auto_room_name = sel_room_text;
              this.designInfo.designCategory = res.designCategory;

              if (res.designCategory == "LianTou") {

                this.designInfo.leftRadian = leftRadian || ''
                this.designInfo.rightRadian = rightRadian || ''
              }
              // console.log(this.designInfo,999);
              this.designInfoTemp = JSON.parse(JSON.stringify(this.designInfo));
            });
          });
      // this.cart_index = [index, index2];
    },
    deleteRoom(index) {
      Dialog.confirm({
        title: "确认提醒",
        message: "删除房间提醒？",
        confirmButtonColor: "rgb(242, 71, 73)",
      })
          .then(() => {
            this.data1.splice(index, 1);
          })
          .catch(() => {
            // on cancel
          });
    },
    deleteItem(index, index2) {
      let shoppingCarId = this.data1[index][index2].shoppingCarId;
      Dialog.confirm({
        title: "确认提醒",
        message: "删除这条购物车？",
        confirmButtonColor: "rgb(242, 71, 73)",
      })
          .then(() => {
            // this.designInfo.cart_index =[index,index2]
            /*this.$store.commit("DELETE_CART_ITEM", this.designInfo).then(() => {
                          this.data1 = this.$store.getters.carts

                      });*/

            this.data1[index].splice(index2, 1); // 删除本地购物车数据
            if (this.data1[index].length == 0) {
              this.data1.splice(index, 1); //
            }
            // 删除购物车
            this.$http
                .post("private/curtainShoppingCar/delete", shoppingCarId)
                .then((res) => {
                  if(res) Toast(res || "删除成功！");
                });
          })
          .catch(() => {
            // on cancel
          });
    },
    onSubmit() {
      //提交订单
      const isMianliao = this.activeHeader == "mianliao" ? 1 : 2; // 面料 或者 成品窗帘
      sessionStorage.setItem("isMianliao", isMianliao || 2);
      this.checkedList = this.checkedList.filter(item=>item != undefined)
      this.$store.commit("SET_CART_CHECKED", this.checkedList )
      let orderid = "";
      this.$router.replace(
          "./confirmorder?order_id=" + orderid + "&isMianliao=" + isMianliao
      );
      return;
    },
  },
};
</script>

<style>
.room-name {
  display: flex;
  padding: 8px 20px;
  justify-content: space-between;
  font-size: 14px;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
  font-weight: 600;
}

.top-info {
  display: flex;

  font-size: 12px;
  line-height: 24px;
  color: #777;
}

.top-info img {
  max-width: 100%;
  width: 100px;
  height: 100px;
  margin-right: 10px;
}

.top-info .info-img {
  max-width: 100%;
  width: 100px;
  margin-left: 5px;
  /*height: 100px;*/
  margin-right: 10px;
  background: no-repeat top center;
  background-size: 100%;
}

.rooms {
  padding: 10px;
  padding-bottom: 50px;
}

.room {
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  margin-bottom: 10px;
}

.room .delete-icon {
  font-weight: 600;
  font-size: 18px;
}

.room .item {
  border-bottom: 1px solid #f7f7f7;
  padding: 10px 0;
}

.room .item:last-child {
  border-bottom: 0;
}

.room .bottom-info .edit-icon {
  background: #f1f1f1;
  width: 35px;
  height: 35px;
  padding: 8px;
  border-radius: 100%;
  box-sizing: border-box;
  margin-right: 10px;
}

.room .bottom-info {
  display: flex;
  font-size: 12px;
  align-items: center;
  color: #777;
}

.cart-page {
  background: #f1f1f1;
  min-height: calc(100vh - 50px);
}

.mianliao-items {
  padding: 10px;
}

.mianliao-item {
  display: flex;
  padding: 10px;
  background: #fff;
}

.mianliao-item .info {
  line-height: 30px;
  width: 100%;
}

.mianliao-item img {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}
</style>
